import type { User } from "@ferrivia/api-contract";
import { FloatingTabBarShell } from "@ferrivia/ui";
import { Outlet, useMatch } from "react-router";
import { NavRail } from "../NavRail";
import { TabBar } from "../TabBar";
import s from "./ConsoleLayout.module.css";

export interface ConsoleLayoutProps {
  user: User;
  onSignOut: () => void;
}

export function ConsoleLayout({ user, onSignOut }: ConsoleLayoutProps) {
  const viewingCustomer = useMatch("/queue/:customerId") !== null;

  return (
    <FloatingTabBarShell className={s.root}>
      <NavRail user={user} onSignOut={onSignOut} />
      <main className={s.content}>
        <Outlet context={user} />
      </main>
      {viewingCustomer ? null : <TabBar user={user} onSignOut={onSignOut} />}
    </FloatingTabBarShell>
  );
}
